import { render, staticRenderFns } from "./ClickThroughDialogButton.vue?vue&type=template&id=453e0498"
import script from "./ClickThroughDialogButton.vue?vue&type=script&lang=ts"
export * from "./ClickThroughDialogButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports